import { Hsl, Hue } from 'annotation-tools/utils';
import {
  defaultLightness,
  defaultSaturation
} from '../../constants/styles/color-def';

export const hueToDefaultHsl = (hue: Hue): Hsl => [
  hue,
  defaultSaturation,
  defaultLightness
];
